import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
/*import {login} from '../../../shared/constants/login'*/
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CookieService } from '@collab/comp-library';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  logo_name!: string;
  email!: string;
  isLogin: boolean = false;
  name: any;
  role: string | null = '';
  public imgUrl!: string;
  public showIcon: boolean = false;

  constructor(
    public router: Router,
    private authService: MsalService,
    private cookie: CookieService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.imgUrl = 'assets/icons/Admin.svg';
    this.setUserDetails();
  }
  public setUserDetails() {
    const userName = this.cookie.getCookie('user_name');
    if (userName && this.authService.instance.getAllAccounts().length > 0) {
      this.name = userName;
      this.cdr.detectChanges();
    }
    this.isLogin = true;
    if (!this.isLogin) {
      this.email = 'avaaipo@ascendion.com';
    }
  }

  public logout() {
    this.authService.logout();
  }

  ngDoCheck() {
    if (this.authService.instance.getAllAccounts().length > 0) {
      this.setUserDetails();
    }
  }
}
